import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative bg-ivory flex items-center py-[48px] md:py-[72px] px-6 overflow-hidden" data-id="element-192">
      <div className="relative z-10 max-w-[1200px] mx-auto w-full grid md:grid-cols-[55%_45%] gap-12 items-center" data-id="element-193">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-194">
          <p className="font-mono text-[11px] tracking-[0.15em] text-cocoa uppercase mb-6" data-id="element-195">
            EBOOK EN ESPAÑOL · SALUD METABÓLICA
          </p>

          <h1 className="font-serif font-[900] text-[58px] leading-[1.08] mb-6 text-text-primary" data-id="element-196">
            <span className="font-normal" data-id="element-197">El Azúcar</span>
            <br data-id="element-198" />
            <span className="italic text-cocoa" data-id="element-199">Silencioso</span>
          </h1>

          <p className="font-lora font-normal text-[18px] leading-[1.75] text-text-secondary max-w-[440px] mb-8" data-id="element-200">
            Lo que el azúcar alta destruye en silencio y que nadie se ha tomado
            el tiempo de explicarte en tu idioma.
          </p>

          <div className="w-10 h-[2px] bg-soft-gold my-8" data-id="element-201"></div>

          <div className="flex items-center gap-4 mb-8" data-id="element-202">
            <span className="font-sans text-[16px] text-text-muted line-through" data-id="element-203">
              $27.00
            </span>
            <span className="text-text-muted text-sm" data-id="element-204">→</span>
            <span className="font-serif font-black text-[32px] text-cocoa" data-id="element-205">
              $17.95
            </span>
            <span className="bg-cocoa/10 text-cocoa font-mono text-[11px] px-3 py-1 rounded-full" data-id="element-206">
              Precio por tiempo limitado
            </span>
          </div>

          <a href="#comprar" className="premium-btn-cocoa block w-full max-w-[380px]" data-id="element-207">
            Descargar Ahora — $17.95
          </a>

          <a href="#comprar" className="block mt-4 text-[13px] text-text-muted underline max-w-[380px] text-center" data-id="element-208">
            Ver solo. Sino tienes imágenes usa temporales para ocupar los
            espacios requerido
          </a>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative flex justify-center md:justify-end" data-id="element-209">
          <img src="https://cdn.magicpatterns.com/uploads/wPrsHojBf5Y7VLzvARouMu/Imagen_Landing_Ebook_Principal.png" alt="El Azúcar Silencioso" className="w-full max-w-[500px] h-auto object-contain" style={{
          filter: 'drop-shadow(0 24px 48px rgba(43,39,36,0.18))'
        }} data-id="element-210" />
        </motion.div>
      </div>
    </section>;
}